export const reactSelectStyles = (theme, error) => ({
  placeholder: (base, state) => ({
    ...base,
    color: theme.field.placeholderColor
  }),
  input: (base, state) => ({
    ...base,
    color: theme.field.textColor,
    padding: 0,
    margin: 0,
    "&:focus-visible": {
      border: `1px solid ${theme.field.borderColorFocus} !important`
    },
  }),
  option: (base, state) => ({
    ...base,
    'img': {
      display: state.isSelected ? 'inline' : 'none',
      float: "right",
      marginTop: "2px"
    },
    backgroundColor: state.isSelected ? theme.field.backgroundColorHover : (state.isFocused ? theme.field.backgroundColorFocus : theme.field.backgroundColor),
    borderRadius: "6px",
    color: theme.field.textColor,
    "&:hover": {
      backgroundColor: theme.field.backgroundColorHover
    },
    "&.disabled": {
      background: theme.field.backgroundColorDisabled
    },
  }),
  control: (base, state) => ({
    ...base,
    background: state.isDisabled ? theme.field.backgroundColorDisabled : theme.field.backgroundColor,
    // match with the menu
    borderRadius: "8px",
    // Overwrittes the different states of border
    borderColor: error ? '#FDA29B' : (state.isFocused ? theme.field.borderColorFocus : theme.field.borderColor),
    "&:hover": {
      borderColor: error ? '#FDA29B' : theme.field.borderColorHover,
    },
    "&.disabled": {
      background: theme.field.borderColorDisabled,
    },
    // Removes weird border around container
    boxShadow: null,
    minHeight: '40px',
    maxHeight: "44px"
  }),
  menu: base => ({
    ...base,
    // override border radius to match the box
    borderRadius: "8px",
    marginTop: "4px",
    boxShadow: `0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08);`,
    border:`1px solid ${theme.field.borderColorMenu}`,
  }),
  menuList: (base, state) => {
    const baseStyle = {
      ...base,
      // kill the white space on first and last option
      padding: "6px",
    };

    if (state && state.selectProps && state.selectProps.isMulti) {
      return {
        ...baseStyle,
        // when used as a multi-select, allow scrolling with a fixed max height
        maxHeight: '240px',
        overflowY: 'auto'
      };
    }

    return baseStyle;
  },
  dropdownIndicator: (base) => ({
    ...base,
    paddingRight: "14px",
    color: theme.field.textColorDisabled,
    "&:hover": {
      color: theme.field.textColorDisabled
    }
   }),
  singleValue: (base) => ({
    ...base,
    color: theme.field.textColor,
    fontSize: "16px",
    lineHeight: "24px",
    margin: "0px"
  }), 
  valueContainer: base => ({
    ...base,
    maxHeight: "44px",
    padding: "0px 14px"
  })
});
export const disabledStyles = theme => ({
  placeholder: (base, state) => ({
    ...base,
    color: theme.field.placeholderColorDisabled,
  }),
  control: (base, state) => ({
    ...base,
    background: `${theme.field.backgroundColorDisabled} !important`,
    border: "1px solid " + theme.field.borderColor,
    color: `${theme.field.textColor} !important`,
    borderRadius: "8px",
    "& input": {
      color: `${theme.field.textColor} !important`,
    },
    // Removes weird border around container
    boxShadow: null,
    minHeight: '40px',    
    maxHeight: "44px"
  }),
  input: (base, state) => ({
    ...base,
    padding: 0,
    margin: 0,
  }),
  singleValue: base => ({
    ...base,
    color: `${theme.field.textColorDisabled} !important`,
    fontSize: "16px",
    lineHeight: "24px",
    margin: "0px"
  }),
  dropdownIndicator: (base) => ({
    ...base,
    paddingRight: "14px",
  }),
  valueContainer: base => ({
    ...base,
    maxHeight: "44px",
    padding: "0px 14px"
  })
});